import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

// internals.addHelperAndDriver = function(helperAndDriver) {
//   helperAndDriver = (({ user, registerType }) => {
//     return {
//       user,
//       registerType
//     }
//   })(helperAndDriver)

//   return vm.$helperAndDriverDataRepository
//     .create(helperAndDriver)
//     .then(result => {
//       helperAndDriver = result.data
//       return helperAndDriver
//     })
//     .catch(error => {
//       console.error('helperAndDriverService.createRegion-error:\n', error)
//       throw error
//     })
// }

internals.addHelperAndDriver = helperAndDriver => {
  helperAndDriver = Object.assign({}, helperAndDriver)

  const promises = []
  return http
    .post('/register', {
      user: helperAndDriver.user,
      registerType: 'Register'
    })
    .then(result => {
      helperAndDriver = result
  
      return Promise.all(promises)
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}

// internals.updateHelperAndDriver = function(helperAndDriver) {
//   helperAndDriver = Object.assign({}, helperAndDriver)
//   helperAndDriver = (({ user, registerType, _id }) => {
//     return {
//       user,
//       registerType,
//       _id
//     }
//   })(helperAndDriver)
//   return vm.$helperAndDriverDataRepository
//     .update(helperAndDriver._id, helperAndDriver)
//     .then(result => {
//       helperAndDriver = result.data
//       return helperAndDriver
//     })
//     .catch(error => {
//       console.error('helperAndDriverUpdate.update-error:\n', error)
//       throw error
//     })
// }

internals.updateHelperAndDriver = helperAndDriver => {
  // helperAndDriver = Object.assign({}, helperAndDriver)

  // delete user.createdAt

  // delete user.createdAt

  // delete user.isDeleted

  // delete user.isEnabled

  // delete user.profileImageUrl

  // delete user.updatedAt

  helperAndDriver = (({ user, registerType, _id }) => {
    return {
      user,
      registerType,
      _id
    }
  })(helperAndDriver)

 

  return http
    .put(`/updateuser`, {
      user: helperAndDriver.user,
      registerType: helperAndDriver.registerType
    })
    .then(result => {
      helperAndDriver = result.data
      return helperAndDriver
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}

internals.staffSearch = function(params,searchItem) {
  return http
    .get(`/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('staffService.inviteUser-error:\n', error)
      throw error
    })
}

internals.dutyTracking = function(id) {
  return http
    .get(`/trip/duty/surveyor/list?id=${id}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('staffService.inviteUser-error:\n', error)
      throw error
    })
}


export default internals



// WEBPACK FOOTER //
// ./src/services/helperanddriver.service.js